var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tagName,_vm._b({tag:"component",class:_vm.cls,attrs:{"role":"button","disabled":_vm.disabled},on:{"click":_vm._clickHandler}},'component',_vm.$attrs,false),[(_vm.loading)?_c('Loading',{attrs:{"size":"sm"}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }